import React from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { blogPosts } from "../blog/blogPosts";
import MainLayout from "../layouts/MainLayout";

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    alert("Link copied to clipboard!");
  };

  const handleShareX = () => {
    // 1. Define your custom introductory message/hook
    const introductoryMessage =
      "Just read this fantastic article! You should check it out:";

    // 2. Combine the elements into the full share text
    const fullShareText = `${introductoryMessage} ${post.title} by @esimitkarlgusta`;

    // 3. Encode the full text
    const text = encodeURIComponent(fullShareText);
    const url = encodeURIComponent(window.location.href);

    // 4. Open the share link
    window.open(
      `https://twitter.com/intent/tweet?text=${text}&url=${url}`,
      "_blank"
    );
  };

  if (!post) {
    return (
      <MainLayout>
        <div className="container mx-auto text-center py-20">
          <p className="text-error text-lg font-semibold">Post not found.</p>
          <Link
            to="/blog"
            className="btn btn-primary mt-6 rounded-full bg-brandPurple text-brandIvory hover:bg-brandPurple/90"
          >
            ← Back to Blog
          </Link>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="bg-brandIvory min-h-screen py-10">
        <div className="container mx-auto px-6 max-w-3xl bg-white rounded-2xl shadow-lg p-10">
          <h1 className="text-4xl font-extrabold text-brandPurple mb-2">
            {post.title}
          </h1>
          <p className="text-sm text-brandPurple/60 mb-4">
            {new Date(post.date).toLocaleDateString()}
          </p>

          {/* Author section */}
          <div className="flex items-center gap-3 mb-8">
            <div>
              <p className="font-semibold text-brandPurple">
                Author: Esimit Karlgusta
              </p>
            </div>
          </div>

          {/* Markdown content */}
          <article
            className="prose prose-lg max-w-none
              prose-h2:text-brandPurple
              prose-h3:text-brandPurple
              prose-a:text-brandGreen
              prose-strong:text-brandPurple
              prose-p:text-brandPurple/90
              prose-li:marker:text-brandPurple"
          >
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {post.content}
            </ReactMarkdown>
          </article>

          {/* Share section */}
          <div className="flex justify-center items-center gap-4 mt-10">
            <button
              onClick={handleShareX}
              className="btn btn-sm bg-[#000] text-white rounded-full hover:bg-[#000]/80"
            >
              Share on X
            </button>
            <button
              onClick={handleCopyLink}
              className="btn btn-sm bg-brandPurple text-brandIvory rounded-full hover:bg-brandPurple/90"
            >
              Copy Link
            </button>
          </div>

          <div className="mt-10 text-center">
            <Link
              to="/blog"
              className="btn btn-sm rounded-full bg-brandPurple text-brandIvory hover:bg-brandPurple/90"
            >
              ← Back to Blog
            </Link>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
